import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-counterclockwise-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", d: "M2.955 6.203A6 6 0 1 0 8.5 2.5" }),
        React.createElement("path", { fill: "currentColor", strokeLinejoin: "round", d: "m6.5 2.5 2-1.75v3.5z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
